// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SlugRouteImport } from './routes/$slug'
import { Route as AgenciasRouteImport } from './routes/agencias'
import { Route as AssinaturasRouteImport } from './routes/assinaturas'
import { Route as BriefingsRouteImport } from './routes/briefings'
import { Route as CalendarioRouteImport } from './routes/calendario'
import { Route as CentralizadoresRouteImport } from './routes/centralizadores'
import { Route as ClientesRouteImport } from './routes/clientes'
import { Route as ComissoesRouteImport } from './routes/comissoes'
import { Route as ConfiguracoesRouteImport } from './routes/configuracoes'
import { Route as ContratosRouteImport } from './routes/contratos'
import { Route as CopilotoComercialRouteImport } from './routes/copiloto-comercial'
import { Route as CrmRouteImport } from './routes/crm'
import { Route as DocumentacaoRouteImport } from './routes/documentacao'
import { Route as FinanceiroRouteImport } from './routes/financeiro'
import { Route as HistoricoRouteImport } from './routes/historico'
import { Route as HistoricoVeiculacaoRouteImport } from './routes/historico-veiculacao'
import { Route as InfluenciadoresRouteImport } from './routes/influenciadores'
import { Route as InventarioRouteImport } from './routes/inventario'
import { Route as LandingPagesRouteImport } from './routes/landing-pages'
import { Route as LayoutsRouteImport } from './routes/layouts'
import { Route as LixeiraRouteImport } from './routes/lixeira'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MateriaisApoioRouteImport } from './routes/materiais-apoio'
import { Route as MetasRouteImport } from './routes/metas'
import { Route as MinhaContaRouteImport } from './routes/minha-conta'
import { Route as MonitoramentoRouteImport } from './routes/monitoramento'
import { Route as NovaCampanhaRouteImport } from './routes/nova-campanha'
import { Route as OwnerRouteImport } from './routes/owner'
import { Route as ParceirosRouteImport } from './routes/parceiros'
import { Route as PedidosInsercaoRouteImport } from './routes/pedidos-insercao'
import { Route as PermutaRouteImport } from './routes/permuta'
import { Route as PiRouteImport } from './routes/pi'
import { Route as PiAnexosRouteImport } from './routes/pi-anexos'
import { Route as PlanejamentoRouteImport } from './routes/planejamento'
import { Route as ProdutosRouteImport } from './routes/produtos'
import { Route as ProjetosEspeciaisRouteImport } from './routes/projetos-especiais'
import { Route as PropostasRouteImport } from './routes/propostas'
import { Route as RedeInventarioRouteImport } from './routes/rede-inventario'
import { Route as RelatorioSincronizacaoRouteImport } from './routes/relatorio-sincronizacao'
import { Route as RelatoriosRouteImport } from './routes/relatorios'
import { Route as SiteRouteImport } from './routes/site'
import { Route as SocialMediaRouteImport } from './routes/social-media'
import { Route as TarefasRouteImport } from './routes/tarefas'
import { Route as UsuariosRouteImport } from './routes/usuarios'
import { Route as VeiculosRouteImport } from './routes/veiculos'
import { Route as AprovarDiretoriaTokenRouteImport } from './routes/aprovar-diretoria.$token'
import { Route as AssinarTokenRouteImport } from './routes/assinar.$token'
import { Route as LandingPagesIdRouteImport } from './routes/landing-pages.$id'
import { Route as LpSlugRouteImport } from './routes/lp.$slug'
import { Route as PosVendaTokenRouteImport } from './routes/pos-venda.$token'
import { Route as SiteIndexRouteImport } from './routes/site.index'
import { Route as SiteContatoRouteImport } from './routes/site.contato'
import { Route as SiteDemoRouteImport } from './routes/site.demo'
import { Route as SiteInventarioRouteImport } from './routes/site.inventario'
import { Route as SitePrecosRouteImport } from './routes/site.precos'
import { Route as SitePrivacidadeRouteImport } from './routes/site.privacidade'
import { Route as SiteRecursosRouteImport } from './routes/site.recursos'
import { Route as SiteTermosRouteImport } from './routes/site.termos'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const SlugRoute = SlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => rootRouteImport
          })
const AgenciasRoute = AgenciasRouteImport.update({
            id: '/agencias',path: '/agencias',getParentRoute: () => rootRouteImport
          })
const AssinaturasRoute = AssinaturasRouteImport.update({
            id: '/assinaturas',path: '/assinaturas',getParentRoute: () => rootRouteImport
          })
const BriefingsRoute = BriefingsRouteImport.update({
            id: '/briefings',path: '/briefings',getParentRoute: () => rootRouteImport
          })
const CalendarioRoute = CalendarioRouteImport.update({
            id: '/calendario',path: '/calendario',getParentRoute: () => rootRouteImport
          })
const CentralizadoresRoute = CentralizadoresRouteImport.update({
            id: '/centralizadores',path: '/centralizadores',getParentRoute: () => rootRouteImport
          })
const ClientesRoute = ClientesRouteImport.update({
            id: '/clientes',path: '/clientes',getParentRoute: () => rootRouteImport
          })
const ComissoesRoute = ComissoesRouteImport.update({
            id: '/comissoes',path: '/comissoes',getParentRoute: () => rootRouteImport
          })
const ConfiguracoesRoute = ConfiguracoesRouteImport.update({
            id: '/configuracoes',path: '/configuracoes',getParentRoute: () => rootRouteImport
          })
const ContratosRoute = ContratosRouteImport.update({
            id: '/contratos',path: '/contratos',getParentRoute: () => rootRouteImport
          })
const CopilotoComercialRoute = CopilotoComercialRouteImport.update({
            id: '/copiloto-comercial',path: '/copiloto-comercial',getParentRoute: () => rootRouteImport
          })
const CrmRoute = CrmRouteImport.update({
            id: '/crm',path: '/crm',getParentRoute: () => rootRouteImport
          })
const DocumentacaoRoute = DocumentacaoRouteImport.update({
            id: '/documentacao',path: '/documentacao',getParentRoute: () => rootRouteImport
          })
const FinanceiroRoute = FinanceiroRouteImport.update({
            id: '/financeiro',path: '/financeiro',getParentRoute: () => rootRouteImport
          })
const HistoricoRoute = HistoricoRouteImport.update({
            id: '/historico',path: '/historico',getParentRoute: () => rootRouteImport
          })
const HistoricoVeiculacaoRoute = HistoricoVeiculacaoRouteImport.update({
            id: '/historico-veiculacao',path: '/historico-veiculacao',getParentRoute: () => rootRouteImport
          })
const InfluenciadoresRoute = InfluenciadoresRouteImport.update({
            id: '/influenciadores',path: '/influenciadores',getParentRoute: () => rootRouteImport
          })
const InventarioRoute = InventarioRouteImport.update({
            id: '/inventario',path: '/inventario',getParentRoute: () => rootRouteImport
          })
const LandingPagesRoute = LandingPagesRouteImport.update({
            id: '/landing-pages',path: '/landing-pages',getParentRoute: () => rootRouteImport
          })
const LayoutsRoute = LayoutsRouteImport.update({
            id: '/layouts',path: '/layouts',getParentRoute: () => rootRouteImport
          })
const LixeiraRoute = LixeiraRouteImport.update({
            id: '/lixeira',path: '/lixeira',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const MateriaisApoioRoute = MateriaisApoioRouteImport.update({
            id: '/materiais-apoio',path: '/materiais-apoio',getParentRoute: () => rootRouteImport
          })
const MetasRoute = MetasRouteImport.update({
            id: '/metas',path: '/metas',getParentRoute: () => rootRouteImport
          })
const MinhaContaRoute = MinhaContaRouteImport.update({
            id: '/minha-conta',path: '/minha-conta',getParentRoute: () => rootRouteImport
          })
const MonitoramentoRoute = MonitoramentoRouteImport.update({
            id: '/monitoramento',path: '/monitoramento',getParentRoute: () => rootRouteImport
          })
const NovaCampanhaRoute = NovaCampanhaRouteImport.update({
            id: '/nova-campanha',path: '/nova-campanha',getParentRoute: () => rootRouteImport
          })
const OwnerRoute = OwnerRouteImport.update({
            id: '/owner',path: '/owner',getParentRoute: () => rootRouteImport
          })
const ParceirosRoute = ParceirosRouteImport.update({
            id: '/parceiros',path: '/parceiros',getParentRoute: () => rootRouteImport
          })
const PedidosInsercaoRoute = PedidosInsercaoRouteImport.update({
            id: '/pedidos-insercao',path: '/pedidos-insercao',getParentRoute: () => rootRouteImport
          })
const PermutaRoute = PermutaRouteImport.update({
            id: '/permuta',path: '/permuta',getParentRoute: () => rootRouteImport
          })
const PiRoute = PiRouteImport.update({
            id: '/pi',path: '/pi',getParentRoute: () => rootRouteImport
          })
const PiAnexosRoute = PiAnexosRouteImport.update({
            id: '/pi-anexos',path: '/pi-anexos',getParentRoute: () => rootRouteImport
          })
const PlanejamentoRoute = PlanejamentoRouteImport.update({
            id: '/planejamento',path: '/planejamento',getParentRoute: () => rootRouteImport
          })
const ProdutosRoute = ProdutosRouteImport.update({
            id: '/produtos',path: '/produtos',getParentRoute: () => rootRouteImport
          })
const ProjetosEspeciaisRoute = ProjetosEspeciaisRouteImport.update({
            id: '/projetos-especiais',path: '/projetos-especiais',getParentRoute: () => rootRouteImport
          })
const PropostasRoute = PropostasRouteImport.update({
            id: '/propostas',path: '/propostas',getParentRoute: () => rootRouteImport
          })
const RedeInventarioRoute = RedeInventarioRouteImport.update({
            id: '/rede-inventario',path: '/rede-inventario',getParentRoute: () => rootRouteImport
          })
const RelatorioSincronizacaoRoute = RelatorioSincronizacaoRouteImport.update({
            id: '/relatorio-sincronizacao',path: '/relatorio-sincronizacao',getParentRoute: () => rootRouteImport
          })
const RelatoriosRoute = RelatoriosRouteImport.update({
            id: '/relatorios',path: '/relatorios',getParentRoute: () => rootRouteImport
          })
const SiteRoute = SiteRouteImport.update({
            id: '/site',path: '/site',getParentRoute: () => rootRouteImport
          })
const SocialMediaRoute = SocialMediaRouteImport.update({
            id: '/social-media',path: '/social-media',getParentRoute: () => rootRouteImport
          })
const TarefasRoute = TarefasRouteImport.update({
            id: '/tarefas',path: '/tarefas',getParentRoute: () => rootRouteImport
          })
const UsuariosRoute = UsuariosRouteImport.update({
            id: '/usuarios',path: '/usuarios',getParentRoute: () => rootRouteImport
          })
const VeiculosRoute = VeiculosRouteImport.update({
            id: '/veiculos',path: '/veiculos',getParentRoute: () => rootRouteImport
          })
const AprovarDiretoriaTokenRoute = AprovarDiretoriaTokenRouteImport.update({
            id: '/aprovar-diretoria/$token',path: '/aprovar-diretoria/$token',getParentRoute: () => rootRouteImport
          })
const AssinarTokenRoute = AssinarTokenRouteImport.update({
            id: '/assinar/$token',path: '/assinar/$token',getParentRoute: () => rootRouteImport
          })
const LandingPagesIdRoute = LandingPagesIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => LandingPagesRoute
          })
const LpSlugRoute = LpSlugRouteImport.update({
            id: '/lp/$slug',path: '/lp/$slug',getParentRoute: () => rootRouteImport
          })
const PosVendaTokenRoute = PosVendaTokenRouteImport.update({
            id: '/pos-venda/$token',path: '/pos-venda/$token',getParentRoute: () => rootRouteImport
          })
const SiteIndexRoute = SiteIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SiteRoute
          })
const SiteContatoRoute = SiteContatoRouteImport.update({
            id: '/contato',path: '/contato',getParentRoute: () => SiteRoute
          })
const SiteDemoRoute = SiteDemoRouteImport.update({
            id: '/demo',path: '/demo',getParentRoute: () => SiteRoute
          })
const SiteInventarioRoute = SiteInventarioRouteImport.update({
            id: '/inventario',path: '/inventario',getParentRoute: () => SiteRoute
          })
const SitePrecosRoute = SitePrecosRouteImport.update({
            id: '/precos',path: '/precos',getParentRoute: () => SiteRoute
          })
const SitePrivacidadeRoute = SitePrivacidadeRouteImport.update({
            id: '/privacidade',path: '/privacidade',getParentRoute: () => SiteRoute
          })
const SiteRecursosRoute = SiteRecursosRouteImport.update({
            id: '/recursos',path: '/recursos',getParentRoute: () => SiteRoute
          })
const SiteTermosRoute = SiteTermosRouteImport.update({
            id: '/termos',path: '/termos',getParentRoute: () => SiteRoute
          })





const LandingPagesRouteChildren = {
  LandingPagesIdRoute: LandingPagesIdRoute
}

const LandingPagesRouteWithChildren = LandingPagesRoute._addFileChildren(LandingPagesRouteChildren)




const SiteRouteChildren = {
  SiteContatoRoute: SiteContatoRoute,SiteDemoRoute: SiteDemoRoute,SiteInventarioRoute: SiteInventarioRoute,SitePrecosRoute: SitePrecosRoute,SitePrivacidadeRoute: SitePrivacidadeRoute,SiteRecursosRoute: SiteRecursosRoute,SiteTermosRoute: SiteTermosRoute,SiteIndexRoute: SiteIndexRoute
}

const SiteRouteWithChildren = SiteRoute._addFileChildren(SiteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,SlugRoute: SlugRoute,AgenciasRoute: AgenciasRoute,AssinaturasRoute: AssinaturasRoute,BriefingsRoute: BriefingsRoute,CalendarioRoute: CalendarioRoute,CentralizadoresRoute: CentralizadoresRoute,ClientesRoute: ClientesRoute,ComissoesRoute: ComissoesRoute,ConfiguracoesRoute: ConfiguracoesRoute,ContratosRoute: ContratosRoute,CopilotoComercialRoute: CopilotoComercialRoute,CrmRoute: CrmRoute,DocumentacaoRoute: DocumentacaoRoute,FinanceiroRoute: FinanceiroRoute,HistoricoRoute: HistoricoRoute,HistoricoVeiculacaoRoute: HistoricoVeiculacaoRoute,InfluenciadoresRoute: InfluenciadoresRoute,InventarioRoute: InventarioRoute,LandingPagesRoute: LandingPagesRouteWithChildren,LayoutsRoute: LayoutsRoute,LixeiraRoute: LixeiraRoute,LoginRoute: LoginRoute,MateriaisApoioRoute: MateriaisApoioRoute,MetasRoute: MetasRoute,MinhaContaRoute: MinhaContaRoute,MonitoramentoRoute: MonitoramentoRoute,NovaCampanhaRoute: NovaCampanhaRoute,OwnerRoute: OwnerRoute,ParceirosRoute: ParceirosRoute,PedidosInsercaoRoute: PedidosInsercaoRoute,PermutaRoute: PermutaRoute,PiRoute: PiRoute,PiAnexosRoute: PiAnexosRoute,PlanejamentoRoute: PlanejamentoRoute,ProdutosRoute: ProdutosRoute,ProjetosEspeciaisRoute: ProjetosEspeciaisRoute,PropostasRoute: PropostasRoute,RedeInventarioRoute: RedeInventarioRoute,RelatorioSincronizacaoRoute: RelatorioSincronizacaoRoute,RelatoriosRoute: RelatoriosRoute,SiteRoute: SiteRouteWithChildren,SocialMediaRoute: SocialMediaRoute,TarefasRoute: TarefasRoute,UsuariosRoute: UsuariosRoute,VeiculosRoute: VeiculosRoute,AprovarDiretoriaTokenRoute: AprovarDiretoriaTokenRoute,AssinarTokenRoute: AssinarTokenRoute,LpSlugRoute: LpSlugRoute,PosVendaTokenRoute: PosVendaTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)